export default "__VITE_ASSET__CyHnLRMU__"